/**
 * Customers, credit and loyalty (docs/LOYALTY.md).
 */
import { z } from 'zod';
import { idSchema, paisaSchema, phoneSchema } from './common.js';
export const upsertCustomerSchema = z.object({
    phone: phoneSchema,
    name: z.string().max(200).optional(),
    email: z.string().email().max(200).optional(),
    cnic: z.string().max(20).optional(),
    address: z.string().max(500).optional(),
    dateOfBirth: z.coerce.date().optional(),
    priceListId: idSchema.optional(),
    notes: z.string().max(1000).optional(),
    creditLimitPaisa: paisaSchema.min(0).optional(),
    /** README.md Phase 26 — credit terms; 0 means "no term, due immediately" (the pre-existing default behavior). */
    creditDays: z.number().int().min(0).max(365).optional(),
    isActive: z.boolean().optional(),
});
export const listCustomersQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    search: z.string().max(200).optional(),
});
export const mergeCustomersSchema = z.object({
    survivingId: idSchema,
    mergedId: idSchema,
});
/* -------------------------------------------------------------------------- */
/* Loyalty                                                                     */
/* -------------------------------------------------------------------------- */
export const redeemQuoteSchema = z.object({
    customerId: idSchema,
    billTotalPaisa: paisaSchema.min(0),
    requestedPoints: z.number().int().min(0).optional(),
});
export const loyaltyAdjustSchema = z.object({
    customerId: idSchema,
    points: z.number().int(),
    note: z.string().min(1).max(300),
});
export const listLoyaltyTxnsQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    customerId: idSchema.optional(),
});
/**
 * Tiers (docs/LOYALTY.md, docs/BUILD-PHASES.md Phase 8). `earnMultiplierBps`
 * (10000 = 1.00x) scales points earned once a customer's `lifetimeSpendPaisa`
 * clears `thresholdSpendPaisa`; `extraDiscountBps` is declared for a future
 * automatic tier discount but nothing reads it yet — same "declared, not
 * wired" pattern as several settings elsewhere in this codebase.
 */
export const upsertLoyaltyTierSchema = z.object({
    name: z.string().min(1).max(60),
    thresholdSpendPaisa: paisaSchema.min(0),
    earnMultiplierBps: z.number().int().min(0).max(100_000).default(10_000),
    extraDiscountBps: z.number().int().min(0).max(10_000).default(0),
    sortOrder: z.number().int().default(0),
    isActive: z.boolean().default(true),
});
//# sourceMappingURL=customers.js.map